var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"fixImg",attrs:{"src":_vm.item.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }